module.exports = __webpack_public_path__ + "static/educative-quiz-poster-2ee3127c643ad35ae6caf47b157fd47e.jpg";